// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"form-header_headerWrapper__bebui","headerTitle":"form-header_headerTitle__hKl9I"};